// Number sequences are no longer a page of their own: a PDF template numbers its documents itself
// (Document › Document number in the template editor). Old links open the record types.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/documents/sequences')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/objects', replace: true });
  },
});
